import { all, call } from "redux-saga/effects"

import BalanceSagas from "./Containers/Balance/saga"
import BusinessDetailsSagas from "./Containers/BusinessDetailsBlock/saga"
import CreditsSagas from "./Containers/CreditsPage/saga"
import HealthSagas from "./Containers/Health/saga"
import MarketingSagas from "./Containers/MarketingPage/saga"
import PaymentMatchingSagas from "./Containers/PaymentMatchingPage/saga"
import PerksAdminSagas from "./Containers/PerksAdminPage/saga"
import PerksSagas from "./Containers/PerksPage/saga"
import PublicApiSagas from "./Containers/PersonalSettings/PublicAPI/saga"
import ReferralsSagas from "./Containers/Referrals/saga"
// import RequestsDescriptorsSagas from './Containers/RequestsPage/RequestsDescriptors/saga';
// InvoiceHistoryBlock, RequestsAutoRefund, RequestsGifts, RequestsIntegrations, RequestsReceipts,
// RequestsVerifiInform, RequestsWithdrawal migrated to Redux Toolkit thunks — see each module's
// redux/ subfolder.
import RequestsSagas from "./Containers/RequestsPage/saga"
import UsersSagas from "./Containers/UsersPage/saga"

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    // call(RequestsDescriptorsSagas),
    call(UsersSagas),
    call(CreditsSagas),
    call(BalanceSagas),
    call(MarketingSagas),
    call(RequestsSagas),
    call(ReferralsSagas),
    call(BusinessDetailsSagas),
    call(PublicApiSagas),
    call(HealthSagas),
    call(PerksSagas),
    call(PerksAdminSagas),
    call(PaymentMatchingSagas)
  ])
}
